import React, {SVGProps} from 'react';
import {ReactComponent} from '../../assets/svg/search-mobile-icon.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
